module.exports = __webpack_public_path__ + "static/action-market-research-9715497459d1a1903de3e1ff4d44add7.svg";